import React, { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { ISchedulingDetail, ISchedulingSearchFields, schedulingService } from './schedulingService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { ModoulTypeList } from '@/types/TcoDs'
import { message, Modal, Input } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'

export const threeInspectionSchedulingModel = createModel(function () {
    const {
        user: { shopCode, createUser, userType, dealerName },
    } = useGlobalModel(({ user }) => [user])

    const settingTypeList = ModoulTypeList
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<ISchedulingDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<ISchedulingSearchFields>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<ISchedulingDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<ISchedulingDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<ISchedulingDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')
    //对账明细打开页面
    const [detailVisible, setDetailVisible] = useState(false)
    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit'>('add')
    //对账明细打开页面
    const [addCarVisible, setAddCarVisible] = useState(false)
    const [editCarVisible, setEditCarVisible] = useState<any>({
        visible: false,
        value: {},
    })

    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: ISchedulingSearchFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            createUserId: shopCode,
            history: 0,
            // fleet: userType === '管理员' ? createUser : undefined,
            // retrieveName: userType === '司机' || userType === '押运员' ? createUser : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            createUser: userType === '超级管理员' ? searchValue.createUser : createUser,
            dealerName: dealerName || undefined,
            departureEndTime: getCurrentDateTime(),
        }
        if (searchParams?.createUser && typeof searchParams.createUser === 'object' && searchParams.createUser.length > 0) {
            searchParams.createUser = searchParams.createUser.join(',') || ''
        }
        let { retData } = await schedulingService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        // setPgCfg(transPgToPagination({ total: records.length, size: 100, current: 1 }))
        setDataSource(records)
        // let { retData: totalList } = await schedulingService.getTotal(shopCode)
        // setTotalNum(totalList)
        setLoading(false)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISchedulingSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const getCurrentDateTime = () => {
        var now = new Date()

        // 获取年、月、日
        var year = now.getFullYear() // 四位数的年份
        var month = (now.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的，所以要+1，并且使用padStart来确保是两位数
        var day = now.getDate().toString().padStart(2, '0') // 使用padStart来确保是两位数

        // 获取小时、分钟、秒
        var hours = now.getHours().toString().padStart(2, '0')
        var minutes = now.getMinutes().toString().padStart(2, '0')
        var seconds = now.getSeconds().toString().padStart(2, '0')

        // 拼接日期时间字符串
        var currentDateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds

        return currentDateTime
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }
    //删除排班
    const sendNotifications = () => {
        globalPrompt('modal', {
            title: '发送通知',
            type: 'warning',
            text: '您已排班完成发送通知？',
            okText: '确认',
            onOk: async () => {
                let notifications = await schedulingService.sendNotifications({ createUserId: shopCode })
                if (notifications.success) {
                    message.success('发送成功!')
                } else {
                    message.success('发送失败!' + notifications.retMsg)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    //删除排班
    const onDelete = (record: ISchedulingDetail) => {
        let deleteReason = ''

        const modalContent = React.createElement(
            'div',
            null,
            React.createElement('p', null, '您正在删除排班是否确认删除？'),
            React.createElement(Input.TextArea, {
                rows: 3,
                placeholder: '请输入删除原因',
                onChange: (e: any) => {
                    deleteReason = e.target.value
                },
                style: { marginTop: '10px' },
            }),
        )

        Modal.confirm({
            title: '删除排班',
            icon: React.createElement(ExclamationCircleOutlined, { style: { color: '#faad14' } }),
            content: modalContent,
            okText: '确认',
            onOk: async () => {
                if (!deleteReason.trim()) {
                    message.warning('请输入删除原因！')
                    return
                }

                let list = record.map((item: ISchedulingDetail) => {
                    return { id: item.id, deleteReason }
                })
                let insertRet = await schedulingService.onDelete(list)
                if (insertRet.success) {
                    message.success('删除成功!')
                } else {
                    message.success('删除失败!' + insertRet.retMsg)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        detailEditForm,
        detailAddForm,
        mode,
        SelectedId,
        settingTypeList,
        totalNum,
        loading,
        addCarVisible,
        editCarVisible,
        /***method***/
        setEditCarVisible,
        setAddCarVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setMode,
        setSelectedId,
        onDelete,
        sendNotifications,
    }
})
